// Code review - In Progress
// Documentation - In Progress
import { useEffect } from "react";
import { useState } from "react";
import { stateMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import DropDown from "../ReusableComponents/DropDown";
import InputText from "../ReusableComponents/InputText";
import MainPopup from "../popup-containers/MainPopup";
import Statepopup from "../popup-containers/Statepopup";
import toast from "react-hot-toast";
import {
  BindAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import GridPage from "../components/GridPage";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import * as XLSX from "sheetjs-style";
import Loader from "../ReusableComponents/Loader";
const State = () => {
  const location = useLocation();
  const [bindStateMasterDatas, setbindStateMasterDatas] = useState([]);

  const [bindStateMasterExcel, setbindStateMasterExcel] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);
  const [visibleSubmit, setVisibleSubmit] = useState(false);
  const [visibleAddScreenTitle, setVisibleAddScreenTitle] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [languageCodeKey, setLanguageCodekey] = useState([]);
  const [languageGetCode, setLanguageGetCode] = useState([]);

  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  // View details start

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [stateData, setstateData] = useState({});
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  // view details end

  const [bindCountriesDD, setBindCountriesDD] = useState([]);
  const [mstStateId, setMstStateId] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [stateError, setStateError] = useState("");
  const [stateCodeError, setStateCodeError] = useState("");

  const [isOpen, setIsOpen] = useState(false);

  // search end
  const showAdd = () => {
    setVisibleAdd(true);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setVisibleTable(false);
    setVisibleSubmit(true);
    setVisibleUpdate(false);
    setVisibleAddScreenTitle(true);
  };

  const cancel = () => {
    getStateTableDatas();
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    setState("");
    setStateCode("");
    setStateError("");
    setStateCodeError("");
    setIsLoading(false);
  };

  useEffect(() => {
    bindStateMasterDatas && getStateTableDatas();
  }, []);

  useEffect(() => {
    // Getting language codes
    var languageKeys = languageCodeKey.map((item) => item.LanguageKey);
    setLanguageGetCode(languageKeys);
  }, [languageCodeKey]);

  useEffect(() => {
    getStateTableDatas();
    // getStateTableExcelDatas();
  }, []);
  const getStateTableExcelDatas = async () => {
    try {
      setIsLoading(true);

      const stateRes = await BindAPI("StateAPI/BindStateExcel");

      setbindStateMasterExcel(stateRes.data.Table || []);
    } catch (error) {
      console.error("Error fetching Excel state data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getStateTableDatas = async () => {
    try {
      setIsLoading(true);

      const [stateRes, countryRes] = await Promise.all([
        BindAPI("StateAPI/BindState"),
        BindAPI("CountryAPI/BindCountry"),
      ]);

      setbindStateMasterDatas(stateRes.data.Table);
      setBindCountriesDD(countryRes.data.Table);
    } catch (error) {
      console.error("Error fetching state/country data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (rowIndex) => {
    // Edit functionality
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setVisibleSubmit(false);
    setVisibleUpdate(true);
    setVisibleAddScreenTitle(false);

    setMstStateId(bindStateMasterDatas[rowIndex].MstStateId);
    setState(bindStateMasterDatas[rowIndex].StateName_en);
    setStateCode(bindStateMasterDatas[rowIndex].StateCode);
  };

  const stateExcelHeader = [
    "S.No",
    "MstStateId",
    "Country",
    "StateName_en",
    "StateName_ta",
    "StateName_hi",
    "StateName_mr",
    "StateName_gu",

    "StateName_kn",
    "StateName_ml",
    "StateName_te",

    "StateName_bn",
    "StateName_or",
    "State Code",
    "Created By",
  ];
  const handleExport = async () => {
    // const stateRes = await BindAPI("StateAPI/BindStateExcel");
    // const rows = stateRes?.data?.Table || [];

    const createdBy = sessionStorage.getItem("createdBy");

    try {
      const stateRes = await BindAPI("StateAPI/BindStateExcel");
      const rows = stateRes?.data?.Table || [];

      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "STATE MASTER",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "mst_state",
            description: "No data available to export",
          },
          "Log/IUDLog",
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "STATE MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_state",
            description: `State Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
      }
      exportData(stateExcelHeader, rows);
    } catch (error) {
      console.error("Export Error:", error);

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "STATE MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_state",
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog",
      );

      toast.error("Failed to export Excel 👎", {
        duration: 1000,
        position: "top-center",
      });
    }
  };

  const exportData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "State Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((col) => ({
      v: col,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const baseStyle = isAlt ? { fill: { fgColor: { rgb: "F0F0F0" } } } : {};

      return [
        { v: index + 1, s: { ...baseStyle } },
        { v: row.MstStateId, s: { ...baseStyle } },
        { v: row.CountryName_en, s: { ...baseStyle } },
        { v: row.StateName_en, s: { ...baseStyle } },
        { v: row.StateName_ta, s: { ...baseStyle } },
        { v: row.StateName_hi, s: { ...baseStyle } },
        { v: row.StateName_mr, s: { ...baseStyle } },
        { v: row.StateName_gu, s: { ...baseStyle } },

        { v: row.StateName_kn, s: { ...baseStyle } },
        { v: row.StateName_ml, s: { ...baseStyle } },
        { v: row.StateName_te, s: { ...baseStyle } },

        { v: row.StateName_bn, s: { ...baseStyle } },
        { v: row.StateName_or, s: { ...baseStyle } },
        { v: row.StateCode, s: { ...baseStyle } },
        { v: row.CreatedByName, s: { ...baseStyle } },
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 6 }, // S.No
      { width: 30 }, // Country
      { width: 30 }, // Country
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 30 }, // State Name
      { width: 15 }, // State Code
      { width: 35 }, // Created By
    ];

    /* ================= ROW HEIGHTS ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyBorders = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyBorders(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "State Master");
    XLSX.writeFile(wb, "State_Master.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  const handleState = (rowIndex, flag) => {
    // Setting visibility in popup container
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setstateData(bindStateMasterDatas[rowIndex]);
  };
  // const handleExport = async() =>  {
  //
  //   const stateRes = await BindAPI("StateAPI/BindStateExcel");

  //  setbindStateMasterExcel(stateRes.data.Table || []);
  //
  //   if ( stateRes.data.Table.length === 0) {
  //     toast.error("No data available to export", {
  //       duration: 1000,
  //       position: "top-center",
  //     });
  //     return;
  //   }

  //   const exportData = stateRes.data.Table.map((item, index) => ({
  //     "S.No": index + 1,
  //     "Country": item.CountryName_en,
  //     "State Name": item.StateName_en,
  //     "State Code": item.StateCode,
  //     "Created By": item.CreatedByName,
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(exportData);

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "State Master");

  //   worksheet["!cols"] = Object.keys(exportData[0]).map((key) => ({
  //     wch: Math.max(
  //       key.length,
  //       ...exportData.map((row) => String(row[key] ?? "").length)
  //     ) + 2,
  //   }));

  //   XLSX.writeFile(workbook, "State_Master.xlsx");

  //   toast.success("Excel exported successfully 👍", {
  //     duration: 1000,
  //     position: "top-center",
  //   });
  // };
  const handleOpen = (isOpen) => {
    // Popup open
    setpopUpOpen(isOpen);
  };

  const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {
    // Submit functionality
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    // Validation end
    if (flag == 1 || flag == 2) {
      // validation start
      let stateValidate = "";
      let stateCodeValidate = "";
      stateValidate =
        state.length > 0
          ? !visibleUpdate &&
            bindStateMasterDatas.find(
              (x) => x.StateName_en.toLowerCase() === state.toLowerCase(),
            )
            ? "State Name already available"
            : ""
          : "Enter State";

      stateCodeValidate =
        stateCode.length > 0
          ? /^[A-Z]{2}$/.test(stateCode)
            ? !visibleUpdate &&
              bindStateMasterDatas.find(
                (x) => x.StateCode.toLowerCase() == stateCode.toLowerCase(),
              )
              ? "State code already available"
              : ""
            : "Enter 2 characters and should be uppercase"
          : "Enter State Code";
      setStateError(stateValidate);
      setStateCodeError(stateCodeValidate);

      if (stateValidate || stateCodeValidate) {
        setIsOpen(true);
      }

      if (!stateValidate && !stateCodeValidate) {
        setIsOpen(false);
        // const languageKeys = [
        //   "ta", // Tamil
        //   "hi", // Hindi
        //   "mr", // Marathi
        //   "gu", // Gujarati
        //   "kn", // Kannada
        //   "ml", // Malayalam
        //   "te", // Telugu
        //   "bn", // Bengali
        //   "or", // Oriya
        // ];
        // const translatedTexts = []; // Create an array to store translations
        // for (let i of languageKeys) {
        //   const translateText = await LanguageTranslatorAPI(state, i);
        //   translatedTexts.push(
        //     translateText.data.data.translations[0].translatedText
        //   );
        // }
        const statePayload = [
          {
            stateCode: stateCode,
            mstStateId: mstStateId ? mstStateId : 0,
            mstCountryId: 1,
            stateNameEn: state,
            stateNameTa: state,
            stateNameHi: state,
            stateNameMr: state,
            stateNameGu: state,
            stateNameKn: state,
            stateNameMl: state,
            stateNameTe: state,
            stateNameBn: state,
            stateNameOr: state,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(statePayload, "StateAPI/IUDState");
        if (flag == 1) {
          // Submit
          if (response.data.Table[0].result === "S") {
            toast.success("State data added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add State data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          // Update

          if (response.data.Table[0].result === "M") {
            toast.success("State data updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update State data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const statePayload = [
        {
          MstCountryId: 1,
          mstStateId: bindStateMasterDatas[items].MstStateId,
          createdBy: createdBy,
          flag: flag,
        },
      ];
      const response = await IUDAPI(statePayload, "StateAPI/IUDState");
      if (flag == 3) {
        // Delete
        if (response.data.Table[0].result === "D") {
          toast.success("State data deleted successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to delete State data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        // Block
        if (response.data.Table[0].result === "B") {
          toast.success("State data blocked successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to block State data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        // Unblock
        if (response.data.Table[0].result === "UB") {
          toast.success("State data unblocked successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to unblock State data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };
  useEffect(() => {
    if (location.pathname == "/statemaster") {
      setVisibleTable(true);
      setVisibleAdd(false);
      getStateTableDatas();
    }
  }, [location]);
  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={"State Master"}
          header={stateMasterHeader}
          records={bindStateMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleState}
          handleExportBtn={true}
          handleExport={handleExport}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full">
          <div class="border-black">
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="State Master"
            />
          </div>

          <div class="mx-auto  md:w-2/5 w-full border-black">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6">
                    <DropDown
                      classDiv="hidden"
                      classStar="text-red-500"
                      title={"Country"}
                      options={[]}
                      placeholder={"Select"}
                      name={"country"}
                      selectedOption={country}
                      controlFunc={(e) => setCountry(e.target.value)}
                    />
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"State"}
                      name={"state"}
                      content={state}
                      controlFunc={(e) => {
                        setState(e.target.value);
                      }}
                      controlFuncBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                        setState(trimmedValue);

                        setStateError(
                          trimmedValue.length > 0
                            ? !visibleUpdate &&
                              bindStateMasterDatas.find(
                                (x) =>
                                  x.StateName_en.toLowerCase() === trimmedValue.toLowerCase()
                              )
                              ? "State Name already available"
                              : ""
                            : "Enter State"
                        );
                      }}
                      errorMessage={stateError}
                    />
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"State Code"}
                      name={"state"}
                      content={stateCode}
                      disabled={visibleUpdate ? visibleUpdate : false}
                      controlFunc={(e) => setStateCode(e.target.value)}
                      controlFuncBlur={(e) => {
                        setStateCodeError(
                          stateCode.length > 0
                            ? /^[A-Z]{2}$/.test(stateCode)
                              ? !visibleUpdate &&
                                bindStateMasterDatas.find(
                                  (x) =>
                                    x.StateCode.toLowerCase() ==
                                    stateCode.toLowerCase(),
                                )
                                ? "State code already available"
                                : ""
                              : "Enter minimum 2 charactor and should be uppercase"
                            : "Enter State Code",
                        );
                      }}
                      errorMessage={stateCodeError}
                    />
                  </form>
                  <Buttons
                    addScreenTitle={visibleSubmit}
                    updateScreenTitle={visibleUpdate}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleState}
      >
        <div>
          <PopUpScreenTitle
            title="State Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Statepopup data={stateData} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default State;
